

const useDateFormat = () => {
  
  const formatDateForDisplay = (date: Date) => {
    const day = ("0" + date.getDate()).slice(-2); // Sørger for to cifre for dagen
    const month = ("0" + (date.getMonth() + 1)).slice(-2); // Sørger for to cifre for måneden
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`; // dd/mm/yyyy format
  };
  
  const formatDateForInput = (date: Date) => {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2); // Sørger for to cifre for måneden
    const day = ("0" + date.getDate()).slice(-2); // Sørger for to cifre for dagen
  
    return `${year}-${month}-${day}`; // yyyy-mm-dd format
  };

  return{
    formatDateForDisplay,
    formatDateForInput
  }
}

export default useDateFormat

